export class QuestionModel {

answerValueField: string;
questionValueField: string;
recFulNameField: string;

}
